<template>
  <div class="el-button back-btn-top" @click="goBack">
    <span class="el-icon-arrow-left"></span>
    <span class="back-text">返回</span>
  </div>
</template>

<script>
  import Bus from '../eventBus.js'
  import { mapState } from 'vuex'
  export default {
    computed: mapState({
      // tmsFullDialog: state => state.common.tmsFullDialog,
    }),
    watch: {
    },
    data() {
      return {
      }
    },

    methods: {
      goBack() {
        this.$store.commit('tmsFullDialog', false)
        window.history.go(-1)
        // 有可能上一个页面也是iframe，需要延迟判断是否关闭iframe
        setTimeout(() => {
          if (!/iframeView/.test(location.href)) Bus.$emit('iframeShowUrl', false)
        }, 300)
      }

    },

    mounted() {

    }
  }

</script>

<style lang="less">
  .back-btn-top {
    position: fixed;
    top: 8px;
    left: 205px;
    padding: 0px 14px !important;
    margin-left: 15px !important;
    z-index: 999;
    height: 35px;
    line-height: 35px !important;
  }
</style>
